import React, { useEffect, useState } from 'react';
import CiamModule from 'ciam-modules';
import 'ciam-modules/style.css';
import authHelper from 'helpers/authHelper';
import { getCIAMEnviroment } from '../helpers';
import localStorageHelper from '../../../helpers/localStorageHelper';
import { formatDate } from 'helpers/dateTimeFormatter';

const UserManagementComponent = (props) => {
    const accessToken = authHelper.getAccessToken();
    const {
        selectedLanguage,
        selectedOrganization = {},
        environmentStageSelector
    } = props.model;

    const [ciamEnv, setCiamEnv] = useState(null);
    const ciamErrorHandler = (error) => {
        console.log('error', error);
    };

    useEffect(() => {
        if (environmentStageSelector) {
            const reqCIAMEnv = getCIAMEnviroment(environmentStageSelector);
            setCiamEnv(reqCIAMEnv);
        }
    }, [environmentStageSelector]);

    const { organizationID } = selectedOrganization;
    const { applicationID } = localStorageHelper.nonEncrypted.getItem('environmentProperties') || {};

    return organizationID && ciamEnv &&
        <div className='user-management-wrapper'>
            <CiamModule
                key={organizationID}
                orgId={organizationID}
                lang={selectedLanguage || 'en'}
                module={'user'}
                environment={ciamEnv}
                headerHeight={10}
                token={accessToken}
                errorCb={ciamErrorHandler}
                applicationId={applicationID}
                formatDateLocale={formatDate}
            />
        </div>;
};

export default UserManagementComponent;

